<template>
  <div>
    <div
      class="match-pair-content"
      :class="{'match-pair-content--disabled': isDisabled}"
    >
      <div
        class="match-pair-item horizontal layout"
        :class="{
          'glass--black': slide.textColour === '#ffffff',
          'glass--white': slide.textColour === '#313131',
        }"
        v-for="(item, index) in slideOptions"
        :key="index"
        @click="clickOption(item)"
        v-show="item.title"
      >
        <div
          class="match-pairs-index horizontal layout center center-justified"
          :style="{'background-color': item.color}"
        >
          {{ index + 1 }}
        </div>
        <div class="flex match-pair-left horizontal layout center">
          {{ item.title }}
        </div>
        <div
          class="match-pair-right"
          :class="`${getResult(item)}`"
        >
          <div class="match-pair-select">
            <div class="default pair-title" v-if="!item.pairSelected">
              {{ $t('Match with...') }}
            </div>
            <div v-else class="pair-title">
              <AhaKey class="bold" :index="item.pairSelected.index" />.
              {{ item.pairSelected.pairTitle }}
            </div>
            <AhaSvg
              name="correct"
              view-box="0 0 18 18"
              maintain-color
              class="aha-option__icon icon-correct"
            />
            <AhaSvg
              name="incorrect"
              view-box="0 0 18 18"
              maintain-color
              class="aha-option__icon icon-incorrect"
            />
            <i class="fas fa-chevron-down" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="match-pair-select-box"
      v-if="selectedOption"
    >
      <div class="overlay-box" @click="clickOption(null)" />
      <MatchPairsSelectAnswer
        :selectedOption="selectedOption"
        :matchPairsOption="matchPairsOption"
        :isFormSubmitted="isFormSubmitted"
        @close="clickOption(null)"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import util from '@/util'

import MatchPairsSelectAnswer from '@/components/quiz/MatchPairsSelectAnswer.vue'
import AhaKey from '../common/Key.vue'

export default {
  components: {
    MatchPairsSelectAnswer,
    AhaKey,
  },
  props: {
    result: {
      type: Object,
      default: () => {},
    },
    isFormSubmitted: {
      type: Boolean,
      default: false,
    },
    isWaitingQuizResult: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedOption: null,
      matchPairsOption: [],
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      slide: (state) => state.slide,
      slideOptions: (state) => state.slide.SlideOptions,
      presentation: (state) => state.presentation,
    }),
    isDisabled() {
      return this.result.timeAnswer >= this.slide.timeToAnswer ||
        this.isFormSubmitted ||
        this.isWaitingQuizResult
    },
  },
  watch: {
    'result.id': function resultUpdated() {
      this.updateResult()
    },
  },
  created() {
    this.$store.state.slide.SlideOptions.forEach((item, key) => {
      item.index = key + 1
      item.color = util.getAhaColor(key)
    })
  },
  mounted() {
    this.matchPairsOption = util.shuffleArrayWithSeed(this.slideOptions, this.slide.id)
      .filter((option) => option.pairTitle)
    this.updateResult()
  },
  methods: {
    updateResult() {
      if (this.slide.quizStatus === 5 && this.result.id && this.result.pairs) {
        this.result.pairs.forEach((pair) => {
          const indexOption = this.slideOptions.findIndex((option) => {
            return option.id === pair.prompt
          })

          const indexPairOption = this.matchPairsOption.findIndex((option) => {
            return option.id === pair.answer
          })

          if (indexOption !== -1 && indexPairOption !== -1) {
            this.$store.state.slide.SlideOptions[indexOption].pairSelected = {
              id: this.matchPairsOption[indexPairOption].id,
              index: indexPairOption + 1,
              pairTitle: this.matchPairsOption[indexPairOption].pairTitle,
            }
          }
          this.matchPairsOption = util.shuffleArrayWithSeed(
            this.slideOptions.filter((option) => option.pairTitle),
            this.slide.id,
          )
          this.$store.dispatch('updateSlide', this.$store.state.slide)
        })
      }
    },
    getResult(option) {
      if (this.slide.quizStatus !== 5 || !this.result.id) return ''
      if (this.presentation.manualRevealCorrectAnswers && !this.presentation.audiencePacing && !this.slide.showCorrectOption) return ''
      if (!this.result.pairs) return 'incorrect'
      const index = this.result.pairs.findIndex((pair) => {
        return pair.prompt === option.id
      })

      if (index !== -1 && this.result.pairs[index].prompt === this.result.pairs[index].answer) {
        return 'correct'
      }
      return 'incorrect'
    },
    clickOption(item) {
      // if (this.isDisabled) return
      this.selectedOption = JSON.parse(JSON.stringify(item))
      this.matchPairsOption.forEach((match) => {
        const index = this.matchPairsOption.findIndex((option) => {
          return option.pairSelected && option.pairSelected.id === match.id
        })
        if (index !== -1) {
          match.pairIndex = this.matchPairsOption[index].index
        } else {
          match.pairIndex = null
        }
      })
      if (item) {
        this.selectedOption.status = this.getResult(item)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.match-pair-content {
  line-height: 1.4;
  text-align: left;
}

.glass--white {
  background: rgba(239, 241, 247, 0.8);
}

.glass--black {
  background: rgba(44, 44, 44, 0.8);
}

.match-pair-item {
  margin: 10px 0;
  border: 1px solid #FFFFFF;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
}

.match-pair-select {
  background-color: #fff;
  padding: 8px;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  position: relative;
  line-height: 19px;
  font-size: 14px;
  border: 2px solid #fff;
  padding-right: 29px;
  text-overflow: ellipsis;
  color: #333333;

  i {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.match-pairs-index {
  width: 24px;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}
.match-pair-left {
  padding: 10px  0 10px 10px;
  font-size: 14px;
  text-align: left;
  word-break: break-word;
  overflow: hidden;
}

.match-pair-select-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000050;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 999;
  padding: 0 10px;
  padding-top: 140px;

  @media (max-width: 400px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.overlay-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.aha-option__icon {
  display: none;
  background-color: #fff;
}

.match-pair-right {
  padding: 10px;
  min-width: 140px;
  max-width: 50%;
  width: 100%;

  &.correct {
    .aha-option__icon {
        position: absolute;
        right: 30px;
        top: 10px;
        border: 1px solid #fff;
        border-radius: 10px;

      &.icon-correct {
        display: block;
      }
    }
    .match-pair-select {
      border: 2px solid #33C173;
      background-color: rgba(51, 193, 115, 0.4);
      padding-right: 50px;
      color: unset;
    }
  }

  &.incorrect {
    .aha-option__icon {
        position: absolute;
        right: 30px;
        top: 10px;
        border: 1px solid #fff;
        border-radius: 10px;

      &.icon-incorrect {
        display: block;
      }
    }
    .match-pair-select {
      border: 2px solid #FF4954;
      background-color: rgba(255, 73, 84, 0.5);
      padding-right: 50px;
      color: unset
    }
  }
}

.pair-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}

.match-pair-content--disabled {
  .match-pair-item {
    // cursor: not-allowed;
  }
  .match-pair-select {
    background: #e8e8e8;
  }
}
</style>
